import React, { Suspense } from "react";
import TransportationForm from "../headerTab/transportation";
import { useSelector } from "react-redux";
import CustomOffices from "../headerTab/customOffices";
import HeaderLevelInfo from "../headerTab/headerLevelInfo";
import { selectTransmissionTypeVal } from "../../selectors";
import { NL_fieldPatterns } from "../../util/NL_fieldPatterns";
import AmendmentReasons from "../headerTab/amendmentReasons";
import { isLastShipmentState } from "../util";
import { useForm, useValidation,useCurrentShipmentType} from "../../../hooks";
import { selectProcedure } from "../../selectors";
const AdditionalDocs=React.lazy(()=> import("./DMS/additionalDocs"))
const Container =React.lazy(()=> import("./DMS/container"))
const SupportingDocuments =React.lazy(()=> import("./DMS/supportingDocuments"))
const PreviousDocuments =React.lazy(()=> import("./DMS/previousDocuments"))
const ExitInformation =React.lazy(()=> import("../headerTab/exitInformation"))



const HeaderForm=()=> {
  const { saveForm }=useForm("header")
  const procedure = useSelector(selectProcedure);
  const transmissionType=useSelector(selectTransmissionTypeVal)
  const {isDMS,isImportShipment,exitInfoStatus,declarationStatus,currentJobState,isDisabled}=useCurrentShipmentType()
  const pattern=React.useMemo(()=>NL_fieldPatterns(isDMS),[isDMS])
  const {validateError,updateError}=useValidation("header")
  const lastShipmentState=isLastShipmentState(declarationStatus)
  const amendState = currentJobState?.includes("AMEND")
  const isTransmissionTypeEXT=transmissionType=="EXT"
  return (

        <div  className="headerDetails formContentareaC88">
            { amendState && <AmendmentReasons isDisabled={isDisabled} />}

          <HeaderLevelInfo exitInfoStatus={exitInfoStatus} declarationStatus={declarationStatus} isDMS={isDMS} isImportShipment={isImportShipment} isTransmissionTypeEXT={isTransmissionTypeEXT} saveForm={saveForm} lastShipmentState={lastShipmentState} validateError={validateError} fieldPattern={pattern}></HeaderLevelInfo>
          <TransportationForm saveForm={saveForm} validateError={validateError} fieldPattern={pattern} isImportShipment={isImportShipment} isDMS={isDMS} />
          
           <CustomOffices updateError={updateError} isImportShipment={isImportShipment} isDMS={isDMS} />
           <Suspense fallback={<div>Loading...</div>}>

           { (procedure !== 'H6' && isDMS) && <Container /> }
        
        {
         (procedure!="I2" && isDMS)  && <SupportingDocuments/>
        }
         
        { isDMS && <AdditionalDocs /> }
        {
         (procedure!="I2" && isDMS) && <PreviousDocuments isImportShipment={isImportShipment} />
        }
         {
            
               (!isImportShipment && isTransmissionTypeEXT) && <ExitInformation isDMS={isDMS} exitInfoCurrentStatus={exitInfoStatus.exitInfoCurrentStatus}  disabled={exitInfoStatus.disabled || lastShipmentState} />
         }
         </Suspense>
        </div>
   
  );
}

export default React.memo(HeaderForm)
